var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4344_4126)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 13.3331L2.86667 10.7331C1.31733 8.44182 1.916 5.48515 4.26667 3.81715C6.61733 2.14981 9.99333 2.28648 12.1633 4.13715C14.3333 5.98848 14.6267 8.98115 12.8493 11.1378C11.072 13.2945 7.77267 13.9478 5.13333 12.6665L2 13.3331Z",
    stroke: "#20262B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.333 3.5C10.333 4.16304 10.5964 4.79893 11.0652 5.26777C11.5341 5.73661 12.17 6 12.833 6C13.496 6 14.1319 5.73661 14.6008 5.26777C15.0696 4.79893 15.333 4.16304 15.333 3.5C15.333 2.83696 15.0696 2.20107 14.6008 1.73223C14.1319 1.26339 13.496 1 12.833 1C12.17 1 11.5341 1.26339 11.0652 1.73223C10.5964 2.20107 10.333 2.83696 10.333 3.5Z",
    fill: "#D85353",
    stroke: "#D85353",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4344_4126"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessage);
export default __webpack_public_path__ + "static/media/message.084abc850ced77649347341da56ef6e2.svg";
export { ForwardRef as ReactComponent };